import { z } from "zod";

import { UserStatusFilter } from "@/types/user.types";

export const UsersSearchParamsSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  search: z.string().optional(),
  permissionGroupIds: z.array(z.string()).optional(),
  status: z.array(z.nativeEnum(UserStatusFilter)).optional(),
});

export type UsersSearchParams = z.infer<typeof UsersSearchParamsSchema>;
